const applyConfig = (config) => {
    const linkAreaPersonale =
      (__CLIENT__ && window.env.RAZZLE_LINK_AREA_PERSONALE) ||
      process.env.RAZZLE_LINK_AREA_PERSONALE ||
      '';
    config.settings = {
    ...config.settings,
    italiaThemeViewsConfig: {
      ...config.settings.italiaThemeViewsConfig,
      imagePosition: 'afterHeader', // possible values: afterHeader, documentBody
    },
    siteProperties: {
      ...config.settings.siteProperties,
      siteTitle: undefined,
      siteSubtitle: undefined,
      subsiteParentSiteTitle: undefined,
      parentSiteTitle: 'Regione Emilia-Romagna',
      parentSiteURL: 'https://regione.emilia-romagna.it',
      arLoginUrl: linkAreaPersonale,
      userLoggedMenu: [
        {
          href: {
            it: linkAreaPersonale,
          },
          title: { it: 'Area personale' },
          className: 'area-personale-link',
        },
        ...(config.settings.siteProperties.userLoggedMenu ?? []),
      ],
    },
    'volto-gdpr-privacy': {
      ...config.settings['volto-gdpr-privacy'],
      defaultPanelConfig: null,
    },
  };

  return config;
};

export default applyConfig;
